import moment from 'moment';

export function DateLocal(){
	let yearMonthLocalConfig = new Date();
	yearMonthLocalConfig.setMonth(yearMonthLocalConfig.getMonth());
	let yearMonthLocal = moment(yearMonthLocalConfig).format('yyyy/MM');
	return yearMonthLocal;
}

export const ClassificationFn = (data) => {
	if (!data || data === 'pc') { // || !data
		data = '01';
	} else if (data === 'de') {
		data = '05';
	} else if (data === 'fr') {
		data = '04';
	} else if ( !data ) {
		data = '';
	}
	return data
};
